export default __webpack_public_path__ + "static/media/lapras.b2a0f3a4.gif";